'use client';

import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import { marketplaceNav } from '@/config/marketplaceNav';
import { MarketplacePageFrame } from '../MarketplacePageFrame';

export function MarketplaceCheckoutReturnContent() {
  const searchParams = useSearchParams();
  const orderId = searchParams.get('order_id')?.trim();
  const cancelled = searchParams.get('checkout') === 'cancelled';

  return (
    <MarketplacePageFrame
      title={cancelled ? 'Checkout cancelled' : 'Checkout complete'}
      description={cancelled ? 'No charge was made.' : 'Thank you for your purchase.'}
    >
      <section className="feed-card settings-page">
        {cancelled ? (
          <p>Your checkout was cancelled. You can return to your cart and try again.</p>
        ) : (
          <p>Your payment was submitted to Stripe. Order details will appear once payment is confirmed.</p>
        )}
        {orderId && !cancelled && (
          <p>
            <Link href={`/marketplace/orders/${orderId}/`} className="btn btn-primary">
              View order
            </Link>
          </p>
        )}
        {orderId && cancelled && (
          <p>
            <Link href={`/marketplace/orders/${orderId}/`}>View unpaid order</Link>
          </p>
        )}
        <p>
          <Link href={marketplaceNav.orders.href} className={orderId && !cancelled ? 'btn btn-ghost' : 'btn btn-primary'}>
            View your orders
          </Link>
        </p>
        <p>
          <Link href={marketplaceNav.shop.href}>Continue shopping</Link>
        </p>
      </section>
    </MarketplacePageFrame>
  );
}
